export default __webpack_public_path__ + "static/media/interface-7.934043a6.png";